export default {"src":"/_next/static/media/VID.bbc56999.svg","height":24,"width":28,"blurWidth":0,"blurHeight":0};